/**
 * Настройки витрины, которые меняются решением заказчика, а не редактированием курса.
 *
 * Раньше жили в courses.data.js — после переезда курсов в БД тот файл исчез,
 * а флаги остались нужны.
 */

/**
 * Показывать ли цены на карточках и в панели записи.
 *
 * Решение заказчика — не показывать: в корпоративном обучении цена зависит от
 * размера группы и формата, поэтому витрина пишет «Стоимость по запросу».
 * Поле priceTenge при этом заполняется в админке и хранится в БД — чтобы включить
 * показ, достаточно поднять флаг.
 */
export const SHOW_PRICES = false;

/**
 * Показывать ли кнопку «Скачать программу».
 *
 * Скрыта: PDF-файлов программ пока нет, и кнопке некуда вести. Когда файлы
 * появятся, поднять флаг и добавить ссылку в поле курса.
 */
export const SHOW_PROGRAM_DOWNLOAD = false;

/**
 * Показывать ли вторую кнопку «Заказать звонок» в полосе призыва на каталоге.
 *
 * Скрыта по решению заказчика: рядом с «Обсудить программу» она размывала
 * основное действие, а телефон и так есть в форме заявки и в подвале.
 */
export const SHOW_CALL_REQUEST = false;
